import { Link } from "react-router-dom";
import { ReactComponent as Logo } from "../logo.svg";
import MenuContext from "../context/MenuContext";
import { useContext } from "react";

function Nav() {
    const { menuVisible, setMenuVisible } = useContext(MenuContext);
    return (
        <nav>
            <div className="underlined-div">
                <Link to="/" className="desktop-nav"><Logo className="logo" /></Link>
                <button aria-label="Menu" className="burger-button mobile-nav" onClick={() => setMenuVisible(!menuVisible)}><Logo className="logo" /></button>
                <ul className="desktop-nav">
                    <Link to="/about" className="nav-main">About</Link>
                    <Link to="/designs" className="nav-main">Designs</Link>
                    <Link to="/projects" className="nav-main">Web Projects</Link>
                </ul>
                <div className="mobile-nav">
                    <ul className={menuVisible ? "active mobile-nav-links" : "mobile-nav-links"}>
                        <Link to="/" className="nav-main" onClick={() => setMenuVisible(!menuVisible)}>Home</Link>
                        <Link to="/about" className="nav-main" onClick={() => setMenuVisible(!menuVisible)}>About</Link>
                        <Link to="/designs" className="nav-main" onClick={() => setMenuVisible(!menuVisible)}>Designs</Link>
                        <Link to="/projects" className="nav-main" onClick={() => setMenuVisible(!menuVisible)}>Web Projects</Link>
                        <Link to="/contact" className="nav-main" onClick={() => setMenuVisible(!menuVisible)}>Let's Talk</Link>
                    </ul>
                </div>
                <Link to="/contact" className="nav-cta desktop-nav">Let's Talk</Link>
            </div>
        </nav>
    )
}

export default Nav;